import React from 'react';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');

  .ls-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .ls-page { font-family: 'Inter', sans-serif; color: #0d1b3e; background: #ffffff; width: 100%; }

  /* ── Hero ── */
  .ls-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .ls-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 600px; height: 600px; border-radius: 50%; background: radial-gradient(circle, rgba(30,58,138,0.09), rgba(13,27,62,0.04)); filter: blur(90px); pointer-events: none; }
  .ls-hero-blob2 { position: absolute; bottom: -15%; left: -10%; width: 720px; height: 720px; border-radius: 50%; background: radial-gradient(circle, rgba(232,163,32,0.08), rgba(30,58,138,0.04)); filter: blur(90px); pointer-events: none; }
  .ls-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .ls-hero-inner { grid-template-columns: 1fr; } .ls-hero-card { display: none; } }

  .ls-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #fef9ee; border: 1px solid #fde68a; font-size: 13px; font-weight: 500; color: #92400e; margin-bottom: 28px; }
  .ls-badge-dot { width: 8px; height: 8px; border-radius: 50%; background: #e8a320; display: inline-block; animation: ls-pulse 2s ease-in-out infinite; }
  @keyframes ls-pulse { 0%, 100% { box-shadow: 0 0 0 0 rgba(232,163,32,0.5); } 50% { box-shadow: 0 0 0 6px rgba(232,163,32,0); } }

  .ls-hero h1 { font-family: 'Playfair Display', Georgia, serif; font-size: clamp(1.8rem, 3.375vw, 2.85rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; color: #0d1b3e; margin-bottom: 24px; }
  .ls-gradient-text { background: linear-gradient(135deg, #1e3a8a 0%, #e8a320 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .ls-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.8; margin-bottom: 40px; font-weight: 400; }
  .ls-btn-group { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 44px; }
  .ls-btn-primary { padding: 14px 28px; background: #0d1b3e; color: #fff; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .ls-btn-primary:hover { background: #1e3a8a; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(13,27,62,0.3); }
  .ls-btn-secondary { padding: 14px 28px; background: #fff; color: #0d1b3e; border: 1.5px solid #cbd5e1; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ls-btn-secondary:hover { border-color: #e8a320; color: #92400e; background: #fef9ee; }

  .ls-trust-items { display: flex; gap: 24px; flex-wrap: wrap; }
  .ls-trust-item { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #64748b; font-weight: 500; }
  .ls-trust-check { width: 20px; height: 20px; background: #dcfce7; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #16a34a; flex-shrink: 0; }

  /* Hero Card */
  .ls-hero-card { background: #fff; border-radius: 24px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,27,62,0.1), 0 4px 16px rgba(0,0,0,0.04); position: relative; }
  .ls-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .ls-card-title-label { font-size: 12px; color: #94a3b8; font-weight: 500; margin-bottom: 3px; }
  .ls-card-title-value { font-size: 16px; font-weight: 700; color: #0d1b3e; }
  .ls-card-badge-live { background: #dcfce7; color: #166534; font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: 999px; }
  .ls-case-item { display: flex; justify-content: space-between; align-items: center; padding: 12px 14px; border-radius: 12px; background: #f8fafc; border: 1px solid #f1f5f9; margin-bottom: 8px; }
  .ls-case-left { display: flex; align-items: center; gap: 12px; }
  .ls-case-icon { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; }
  .ls-case-name { font-size: 13px; font-weight: 600; color: #334155; }
  .ls-case-type { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .ls-case-status { font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 999px; white-space: nowrap; }
  .ls-status-active { background: #dcfce7; color: #166534; }
  .ls-status-review { background: #fef9c3; color: #854d0e; }
  .ls-status-closed { background: #dbeafe; color: #1e40af; }
  .ls-card-metric { margin-top: 16px; padding: 18px 20px; background: linear-gradient(135deg, #0d1b3e, #1e3a8a); border-radius: 14px; display: flex; justify-content: space-between; align-items: center; }
  .ls-card-metric-label { font-size: 11px; color: rgba(255,255,255,0.7); font-weight: 500; margin-bottom: 4px; }
  .ls-card-metric-value { font-size: 26px; font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .ls-card-metric-badge { background: rgba(232,163,32,0.25); border: 1px solid rgba(232,163,32,0.45); border-radius: 999px; padding: 5px 12px; font-size: 12px; font-weight: 600; color: #fbbf24; }

  /* ── Stats Bar ── */
  .ls-stats { background: #fff; border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .ls-stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .ls-stats-grid { grid-template-columns: 1fr 1fr; } }
  .ls-stat-item { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .ls-stat-item:last-child { border-right: none; }
  @media (max-width: 768px) { .ls-stat-item:nth-child(2n) { border-right: none; } .ls-stat-item { border-bottom: 1px solid #f1f5f9; } }
  .ls-stat-num { font-family: 'Playfair Display', serif; font-size: 2.2rem; font-weight: 800; color: #1e3a8a; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; }
  .ls-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ── Shared Section Atoms ── */
  .ls-section { padding: 96px 24px; }
  .ls-container { max-width: 1200px; margin: 0 auto; }
  .ls-section-header { text-align: center; max-width: 720px; margin: 0 auto 64px; }
  .ls-section-header h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .ls-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.78; }
  .ls-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #e8a320; margin-bottom: 12px; }

  /* ── Services ── */
  .ls-services-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .ls-services-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
  @media (max-width: 960px) { .ls-services-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 600px) { .ls-services-grid { grid-template-columns: 1fr; } }
  .ls-svc-card { background: #fff; padding: 36px 30px; border-radius: 20px; border: 1px solid rgba(226,232,240,0.7); box-shadow: 0 1px 4px rgba(0,0,0,0.03); transition: all 0.3s; position: relative; overflow: hidden; cursor: pointer; }
  .ls-svc-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.09); transform: translateY(-3px); border-color: transparent; }
  .ls-svc-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; opacity: 0; transition: opacity 0.3s; border-radius: 20px 20px 0 0; }
  .ls-svc-card:hover::before { opacity: 1; }
  .ls-svc-card.c-navy::before { background: linear-gradient(90deg, #0d1b3e, #1e3a8a); }
  .ls-svc-card.c-gold::before { background: linear-gradient(90deg, #d97706, #e8a320); }
  .ls-svc-card.c-blue::before { background: linear-gradient(90deg, #1e3a8a, #3b82f6); }
  .ls-svc-icon { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 22px; margin-bottom: 20px; }
  .ls-svc-icon.i-navy { background: #eef2ff; }
  .ls-svc-icon.i-gold { background: #fef9ee; }
  .ls-svc-icon.i-blue { background: #dbeafe; }
  .ls-svc-title { font-size: 1.05rem; font-weight: 700; color: #0d1b3e; margin-bottom: 12px; }
  .ls-svc-desc { font-size: 0.9rem; color: #64748b; line-height: 1.72; }
  .ls-svc-link { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: #1e3a8a; margin-top: 18px; cursor: pointer; opacity: 0; transition: opacity 0.3s; pointer-events: none; }
  .ls-svc-card:hover .ls-svc-link { opacity: 1; }

  /* ── Why Choose Us ── */
  .ls-why-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }
  @media (max-width: 900px) { .ls-why-grid { grid-template-columns: 1fr; gap: 48px; } }
  .ls-why-left h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.6rem); font-weight: 800; color: #0d1b3e; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 18px; }
  .ls-why-left p { font-size: 1.02rem; color: #64748b; line-height: 1.78; margin-bottom: 44px; }
  .ls-benefit-list { display: flex; flex-direction: column; gap: 28px; }
  .ls-benefit-item { display: flex; gap: 18px; }
  .ls-benefit-icon-wrap { width: 44px; height: 44px; border-radius: 12px; background: #eef2ff; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; margin-top: 2px; }
  .ls-benefit-title { font-size: 1rem; font-weight: 700; color: #0d1b3e; margin-bottom: 6px; }
  .ls-benefit-desc { font-size: 0.9rem; color: #64748b; line-height: 1.65; }

  /* Testimonial card */
  .ls-testimonial-card { background: linear-gradient(145deg, #0d1b3e, #1e3a8a); border-radius: 28px; padding: 48px 40px; position: relative; overflow: hidden; }
  .ls-test-deco1 { position: absolute; top: -40px; right: -40px; width: 200px; height: 200px; border-radius: 50%; background: rgba(232,163,32,0.12); pointer-events: none; }
  .ls-test-deco2 { position: absolute; bottom: -60px; left: -30px; width: 260px; height: 260px; border-radius: 50%; background: rgba(255,255,255,0.04); pointer-events: none; }
  .ls-test-quote-mark { font-family: Georgia, serif; font-size: 80px; color: rgba(232,163,32,0.35); line-height: 1; margin-bottom: 4px; position: relative; z-index: 1; }
  .ls-test-body { font-size: 1.05rem; color: rgba(255,255,255,0.88); line-height: 1.8; margin-bottom: 32px; font-style: italic; position: relative; z-index: 1; }
  .ls-test-author { display: flex; align-items: center; gap: 14px; position: relative; z-index: 1; margin-bottom: 28px; }
  .ls-test-avatar { width: 50px; height: 50px; border-radius: 50%; background: rgba(232,163,32,0.22); border: 2px solid rgba(232,163,32,0.45); display: flex; align-items: center; justify-content: center; font-size: 18px; font-weight: 700; color: #fbbf24; flex-shrink: 0; }
  .ls-test-name { font-size: 15px; font-weight: 700; color: #fff; }
  .ls-test-role { font-size: 12px; color: rgba(255,255,255,0.6); margin-top: 2px; }
  .ls-test-stars { display: flex; gap: 3px; position: relative; z-index: 1; }
  .ls-test-star { color: #fbbf24; font-size: 18px; }
  .ls-test-verified { font-size: 12px; color: rgba(255,255,255,0.6); margin-top: 8px; position: relative; z-index: 1; }

  /* ── Process ── */
  .ls-process-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.6); border-bottom: 1px solid rgba(226,232,240,0.6); }
  .ls-process-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 40px; position: relative; }
  @media (max-width: 768px) { .ls-process-grid { grid-template-columns: 1fr; } }
  .ls-process-grid::before { content: ''; position: absolute; top: 27px; left: 20%; right: 20%; height: 2px; background: linear-gradient(90deg, #1e3a8a, #e8a320); z-index: 0; }
  @media (max-width: 768px) { .ls-process-grid::before { display: none; } }
  .ls-process-step { text-align: center; position: relative; z-index: 1; }
  .ls-process-num-wrap { margin: 0 auto 24px; width: 56px; height: 56px; }
  .ls-process-num { width: 56px; height: 56px; border-radius: 50%; background: #0d1b3e; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; border: 4px solid #f8fafc; box-shadow: 0 0 0 2px #0d1b3e; }
  .ls-process-title { font-size: 1.05rem; font-weight: 700; color: #0d1b3e; margin-bottom: 10px; }
  .ls-process-desc { font-size: 0.9rem; color: #64748b; line-height: 1.72; max-width: 240px; margin: 0 auto; }

  /* ── CTA ── */
  .ls-cta { background: linear-gradient(135deg, #0d1b3e 0%, #1e3a8a 55%, #0d2557 100%); padding: 100px 24px; position: relative; overflow: hidden; }
  .ls-cta-blob1 { position: absolute; top: -100px; right: -80px; width: 420px; height: 420px; border-radius: 50%; background: rgba(232,163,32,0.07); filter: blur(60px); pointer-events: none; }
  .ls-cta-blob2 { position: absolute; bottom: -80px; left: -60px; width: 360px; height: 360px; border-radius: 50%; background: rgba(255,255,255,0.04); filter: blur(60px); pointer-events: none; }
  .ls-cta-inner { max-width: 720px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
  .ls-cta-tag { display: inline-block; background: rgba(232,163,32,0.18); border: 1px solid rgba(232,163,32,0.35); border-radius: 999px; padding: 6px 16px; font-size: 12px; font-weight: 700; color: #fbbf24; letter-spacing: 0.08em; text-transform: uppercase; margin-bottom: 24px; }
  .ls-cta h2 { font-family: 'Playfair Display', serif; font-size: clamp(1.5rem, 3vw, 2.4rem); font-weight: 800; color: #fff; margin-bottom: 20px; line-height: 1.2; letter-spacing: -0.02em; }
  .ls-cta p { font-size: 1.1rem; color: rgba(255,255,255,0.8); line-height: 1.75; margin-bottom: 44px; }
  .ls-cta-btn-group { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; margin-bottom: 40px; }
  .ls-cta-btn-primary { padding: 16px 32px; background: #e8a320; color: #fff; border: none; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; letter-spacing: 0.01em; }
  .ls-cta-btn-primary:hover { background: #d97706; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(232,163,32,0.4); }
  .ls-cta-btn-secondary { padding: 16px 32px; background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,0.35); border-radius: 10px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ls-cta-btn-secondary:hover { border-color: rgba(255,255,255,0.65); background: rgba(255,255,255,0.07); }
  .ls-cta-reassurances { display: flex; gap: 28px; justify-content: center; flex-wrap: wrap; }
  .ls-cta-reassurance { display: flex; align-items: center; gap: 8px; font-size: 13.5px; color: rgba(255,255,255,0.72); font-weight: 500; }
  .ls-cta-check { width: 20px; height: 20px; background: rgba(232,163,32,0.22); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #fbbf24; flex-shrink: 0; }
`;

const caseItems = [
  { icon: "📄", name: "Vendor Agreement", type: "Contract Review", status: "In Review", statusClass: "ls-status-review", bgColor: "#fef9ee" },
  { icon: "🏢", name: "TechFlow Inc.", type: "Entity Formation", status: "Active", statusClass: "ls-status-active", bgColor: "#f0fdf4" },
  { icon: "⚖️", name: "IP Protection", type: "Trademark Filing", status: "Closed", statusClass: "ls-status-closed", bgColor: "#eff6ff" },
  { icon: "👔", name: "Employment Policy", type: "Compliance Audit", status: "Active", statusClass: "ls-status-active", bgColor: "#f0fdf4" },
];

const stats = [
  { num: "5,000+", label: "Businesses Served" },
  { num: "$3.5M+", label: "Saved in Legal Fees" },
  { num: "98%", label: "Client Satisfaction" },
  { num: "20+", label: "Years Combined Experience" },
];

const services = [
  { icon: "📝", title: "Contract Drafting & Review", desc: "Professional contract creation and review to protect your business interests and ensure every agreement works in your favor.", color: "c-navy", iconBg: "i-navy", slug: "contracts" },
  { icon: "🏢", title: "Business Entity Formation", desc: "Expert guidance on choosing and establishing the right legal structure — LLC, S-Corp, or C-Corp — for your unique goals.", color: "c-gold", iconBg: "i-gold", slug: "entity-formation" },
  { icon: "🛡️", title: "Regulatory Compliance", desc: "Stay ahead of federal, state, and local regulations with ongoing compliance monitoring and proactive legal support.", color: "c-blue", iconBg: "i-blue", slug: "regulatory-compliance" },
  { icon: "👔", title: "Employment Law", desc: "Navigate employment contracts, HR policies, and workplace compliance to reduce liability and protect your team.", color: "c-navy", iconBg: "i-navy", slug: "employment-law" },
  { icon: "💡", title: "Intellectual Property", desc: "Protect your trademarks, copyrights, patents, and trade secrets with a comprehensive IP strategy tailored to your brand.", color: "c-gold", iconBg: "i-gold", slug: "ip-protection" },
  { icon: "⚖️", title: "Dispute Resolution", desc: "Efficient mediation, arbitration, and legal representation to resolve business disputes swiftly and cost-effectively.", color: "c-blue", iconBg: "i-blue", slug: "dispute-resolution" },
];

const benefits = [
  { icon: "⏱️", title: "Save Time & Reduce Stress", desc: "Focus on growing your business while we handle every legal complexity — no more late nights worrying about contracts." },
  { icon: "💰", title: "Flat-Rate, Transparent Pricing", desc: "No surprise bills or hidden fees. Know exactly what you'll pay upfront with our straightforward pricing model." },
  { icon: "⚡", title: "24-Hour Response Guarantee", desc: "Get expert legal advice when you need it most. Our team responds to all inquiries within 24 hours, guaranteed." },
  { icon: "🔒", title: "Proactive Legal Protection", desc: "We don't just react to problems — we anticipate them. Ongoing support keeps you protected before issues arise." },
];

const processSteps = [
  { num: "01", title: "Book a Free Consultation", desc: "Tell us about your business and legal needs. We'll match you with the right attorney and outline a clear plan of action." },
  { num: "02", title: "Receive Your Legal Strategy", desc: "We develop a customized legal plan tailored to your business goals, risk profile, and budget — no one-size-fits-all." },
  { num: "03", title: "Stay Protected Year-Round", desc: "With ongoing support, contract monitoring, and compliance alerts, your business stays legally secure every single day." },
];

const LegalServices = () => {
  const { navigateTo } = useNavigation();

  return (
    <div className="ls-page">
      <style>{styles}</style>

      {/* ── Hero ── */}
      <section className="ls-hero">
        <div className="ls-hero-blob1" />
        <div className="ls-hero-blob2" />
        <div className="ls-hero-inner">
          <div>
            <div className="ls-badge">
              <span className="ls-badge-dot" />
              Trusted Legal Partner for Small Business
            </div>
            <h1>
              Business Legal Services{" "}
              <span className="ls-gradient-text">Built for Growth</span>
            </h1>
            <p className="ls-hero-sub">
              From contracts and compliance to disputes and IP protection — expert
              legal counsel designed specifically for the challenges small
              businesses face every day.
            </p>
            <div className="ls-btn-group">
              <button className="ls-btn-primary">Free Consultation →</button>
              <button className="ls-btn-secondary">Explore Services</button>
            </div>
            <div className="ls-trust-items">
              {["No obligation", "Fixed-rate pricing", "24-hr response", "5,000+ businesses served"].map((t, i) => (
                <div key={i} className="ls-trust-item">
                  <span className="ls-trust-check">✓</span>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="ls-hero-card">
            <div className="ls-card-header">
              <div>
                <div className="ls-card-title-label">Active Cases</div>
                <div className="ls-card-title-value">Legal Dashboard</div>
              </div>
              <span className="ls-card-badge-live">● Live</span>
            </div>
            {caseItems.map((item, i) => (
              <div key={i} className="ls-case-item">
                <div className="ls-case-left">
                  <div className="ls-case-icon" style={{ background: item.bgColor }}>
                    {item.icon}
                  </div>
                  <div>
                    <div className="ls-case-name">{item.name}</div>
                    <div className="ls-case-type">{item.type}</div>
                  </div>
                </div>
                <span className={`ls-case-status ${item.statusClass}`}>{item.status}</span>
              </div>
            ))}
            <div className="ls-card-metric">
              <div>
                <div className="ls-card-metric-label">Cases Resolved This Month</div>
                <div className="ls-card-metric-value">47</div>
              </div>
              <div className="ls-card-metric-badge">↑ 12%</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats Bar ── */}
      <section className="ls-stats">
        <div className="ls-stats-grid">
          {stats.map((s, i) => (
            <div key={i} className="ls-stat-item">
              <div className="ls-stat-num">{s.num}</div>
              <div className="ls-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Services ── */}
      <section className="ls-section ls-services-bg">
        <div className="ls-container">
          <div className="ls-section-header">
            <div className="ls-kicker">What We Do</div>
            <h2>Comprehensive Legal Solutions</h2>
            <p>
              From day-to-day contracts to complex compliance matters — we provide
              the legal backbone your business needs to operate with confidence and
              clarity.
            </p>
          </div>
          <div className="ls-services-grid">
            {services.map((svc, i) => (
              <div key={i} className={`ls-svc-card ${svc.color}`} onClick={() => navigateTo(svc.slug)}>
                <div className={`ls-svc-icon ${svc.iconBg}`}>{svc.icon}</div>
                <div className="ls-svc-title">{svc.title}</div>
                <div className="ls-svc-desc">{svc.desc}</div>
                <div className="ls-svc-link">Explore this service →</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="ls-section">
        <div className="ls-container">
          <div className="ls-why-grid">
            <div className="ls-why-left">
              <div className="ls-kicker">Why Choose Us</div>
              <h2>Legal Expertise That Works as Hard as You Do</h2>
              <p>
                We understand the unique challenges small businesses face. Our
                legal team brings enterprise-grade expertise with small-business
                sensibility — accessible, affordable, and always in your corner.
              </p>
              <div className="ls-benefit-list">
                {benefits.map((b, i) => (
                  <div key={i} className="ls-benefit-item">
                    <div className="ls-benefit-icon-wrap">{b.icon}</div>
                    <div>
                      <div className="ls-benefit-title">{b.title}</div>
                      <div className="ls-benefit-desc">{b.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="ls-testimonial-card">
              <div className="ls-test-deco1" />
              <div className="ls-test-deco2" />
              <div className="ls-test-quote-mark">"</div>
              <p className="ls-test-body">
                Having BizServe's legal team in our corner has been a game-changer.
                They helped us navigate our first major contract negotiation, set up
                our LLC, and even handled an employment dispute — all without
                breaking the bank. I can't imagine running our business without them.
              </p>
              <div className="ls-test-author">
                <div className="ls-test-avatar">JR</div>
                <div>
                  <div className="ls-test-name">James Rodriguez</div>
                  <div className="ls-test-role">Founder, TechFlow Solutions</div>
                </div>
              </div>
              <div className="ls-test-stars">
                {[1, 2, 3, 4, 5].map((n) => (
                  <span key={n} className="ls-test-star">★</span>
                ))}
              </div>
              <div className="ls-test-verified">5.0 · Verified Client Review</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Process ── */}
      <section className="ls-section ls-process-bg">
        <div className="ls-container">
          <div className="ls-section-header">
            <div className="ls-kicker">How It Works</div>
            <h2>From Consultation to Protection in 3 Steps</h2>
            <p>
              Our streamlined onboarding process gets you legal coverage fast — no
              lengthy intake forms or weeks of waiting.
            </p>
          </div>
          <div className="ls-process-grid">
            {processSteps.map((step, i) => (
              <div key={i} className="ls-process-step">
                <div className="ls-process-num-wrap">
                  <div className="ls-process-num">{step.num}</div>
                </div>
                <div className="ls-process-title">{step.title}</div>
                <div className="ls-process-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="ls-cta">
        <div className="ls-cta-blob1" />
        <div className="ls-cta-blob2" />
        <div className="ls-cta-inner">
          <div className="ls-cta-tag">Free Consultation Available</div>
          <h2>Ready to Protect Your Business?</h2>
          <p>
            Join over 5,000 small businesses that trust BizServe for their legal
            needs. Schedule your free consultation today and discover how expert
            legal counsel can help your business grow with confidence.
          </p>
          <div className="ls-cta-btn-group">
            <button className="ls-cta-btn-primary">Schedule Free Consultation</button>
            <button className="ls-cta-btn-secondary">View Pricing Plans</button>
          </div>
          <div className="ls-cta-reassurances">
            {["No obligation consultation", "Fixed-rate transparent pricing", "24-hour response time", "Cancel anytime"].map((r, i) => (
              <div key={i} className="ls-cta-reassurance">
                <span className="ls-cta-check">✓</span>
                {r}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalServices;
